import API from 'app/gamma/src/api';
import { AnnouncementResponse, StandardThunkAction } from 'app/gamma/src/types';
import { Action, actionCreator } from 'app/gamma/src/util/actions';

// Action types
export const ANNOUNCEMENTS_REQUEST = Symbol('loaders/ANNOUNCEMENTS_REQUEST');
export const ANNOUNCEMENTS_SUCCESS = Symbol('loaders/ANNOUNCEMENTS_SUCCESS');
export const ANNOUNCEMENTS_ERROR = Symbol('loaders/ANNOUNCEMENTS_ERROR');

export type AnnouncementsRequestAction = Action<
  typeof ANNOUNCEMENTS_REQUEST,
  null
>;
export type AnnouncementsSuccessAction = Action<
  typeof ANNOUNCEMENTS_SUCCESS,
  AnnouncementResponse[]
>;
export type AnnouncementsErrorAction = Action<
  typeof ANNOUNCEMENTS_ERROR,
  Error
>;

// Action creators
const announcementsRequest = actionCreator<AnnouncementsRequestAction>(
  ANNOUNCEMENTS_REQUEST,
);
const announcementsSuccess = actionCreator<AnnouncementsSuccessAction>(
  ANNOUNCEMENTS_SUCCESS,
);
const announcementsError = actionCreator<AnnouncementsErrorAction>(
  ANNOUNCEMENTS_ERROR,
);

export const loadAnnouncements = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(announcementsRequest());

      const announcements = await API.client.announcements();

      dispatch(announcementsSuccess(announcements));
    } catch (err) {
      dispatch(announcementsError(err));
    }
  };
};

export const loadAllAnnouncements = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(announcementsRequest());

      const announcements = await API.client.allAnnouncements();

      dispatch(announcementsSuccess(announcements));
    } catch (err) {
      dispatch(announcementsError(err));
    }
  };
};
